// extracted by mini-css-extract-plugin
module.exports = {"icon":"_5D1Thcyj","icon--has-avatar":"_5D3iSnnf","icon-image":"_5D2UmpQU","label":"_5D1oktR-","menu-item":"_5D1cRkq8","menu-item--dropdown-value":"_5D2Kcb0U"};